<template>
  <v-dialog v-model="dialog" width="1000" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon>business</v-icon>
        {{ form.id ? $t("parametro.crud.editParametro") : "Nuevo funcionario" }}
        <v-spacer />
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          Datos Básicos
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs3>
                <v-autocomplete
                  v-model="persona.id_tipo_documento"
                  :items="tipo_de_documentos"
                  item-text="descripcion"
                  :item-value="(val) => parseInt(val.id)"
                  :rules="$validate(['required'])"
                  label="Tipo de documento"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  @change="obtenerNrodoc()"
                  label="Número de Documento"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.nro_doc"
                  maxlength="11"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  label="Complemento"
                  required
                  v-model="persona.nro_complemento"
                  maxlength="6"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-autocomplete
                  v-model="persona.expedido"
                  :items="tipo_expedido"
                  item-text="valor"
                  item-value="valor"
                  label="Expedido en"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2>
                <v-select
                  label="Sexo"
                  :items="generos"
                  item-text="nombre"
                  item-value="value"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.sexo"
                  maxlength="1"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Paterno"
                  required
                  v-model="persona.ap_paterno"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Materno"
                  required
                  v-model="persona.ap_materno"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  label="Apellido Casada"
                  required
                  v-model="persona.ap_casada"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nombres"
                  :rules="$validate(['required'])"
                  required
                  v-model="persona.nombres"
                  maxlength="50"
                  class="mayuscula"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

          Alta del Servidor Publico
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs3>
                <v-text-field
                  v-model="date"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha de incorporación"
                  type="date"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-autocomplete
                  :items="itemsDisponibles"
                  item-text="id_item"
                  :item-value="(val) => val.id_item"
                  :rules="$validate(['required'])"
                  required
                  label="ITEM"
                  :loading="loading"
                  @change="cargarDatos()"
                  v-model="form.nro_item"
                />
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="unidades"
                  label="Unidad"
                  item-text="nombre_unidad"
                  item-value="id"
                  :rules="$validate(['required'])"
                  required
                  v-model="movilidad.id_unidad"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs4>
                <v-autocomplete
                  v-model="movilidad.id_cargo"
                  :items="tipo_cargo"
                  item-text="denominacion"
                  item-value="id"
                  label="Seleccione Cargo"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  v-model="movilidad.id_puesto"
                  :items="tipo_puesto"
                  item-text="denominacion"
                  item-value="id"
                  label="Seleccione Puesto"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  label="Nro de Memorándum"
                  :rules="$validate(['required'])"
                  required
                  v-model="movilidad.nro_memorandum"
                  maxlength="50"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :disabled="!valid"
            :loading="loading"
            v-if="!repetido"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
      persona: {
        ap_paterno: "",
        ap_materno: "",
      },
      movilidad: {},
      valid: true,
      tipo_de_documentos: [],
      tipo_expedido: [],
      tipo_cargo: [],
      tipo_puesto: [],
      unidades: [],
      movilidad: {},
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      estado_boton: false,
      generos: [
        { value: "M", nombre: "MASCULINO" },
        { value: "F", nombre: "FEMENINO" },
      ],
      loading: false,
      respuestaf: [],
      itemsDisponibles: [],
      repetido: false
    };
  },
  mounted() {
    this.$refs.form.validate()
    this.$bus.$on("openDialogCrearPersona", () => {
      this.dialog = true;
    });
    this.obtenerTipoDocumentos();
    this.obtenerTipoExpedicion();
    this.obtenerCargos();
    this.obtenerPuestos();
    this.obtenerUnidad();
    this.obtenerItemsDisponibles();
  },

  methods: {
    convertirMayuscula(valor) {
      return valor.toUpperCase();
    },
    close() {
      this.dialog = false;
      this.persona = {
        ap_paterno: "",
        ap_materno: "",
      };
      this.movilidad = {};
      this.form = {};
      this.date = null;
      this.$bus.$emit("closeDialog");
    },
    prueba() {
      console.log("evento ACTIVADO: ", this.form.item);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async obtenerTipoDocumentos() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
          	tipoDocumentos{
          		rows{
          			id
          			descripcion
          		}
          	}
          }
          `,
      });
      //console.log(respuesta)
      this.tipo_de_documentos = respuesta.tipoDocumentos.rows;
    },
    async obtenerNrodoc() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            personaFindNroDoc(nro_doc:"${this.persona.nro_doc}"){
              id
              ap_paterno
              ap_materno
              ap_casada
              nombres
              id_tipo_documento
              nro_doc
              nro_complemento
              sexo
              expedido
              movilidades{
                id
              }
            }
          }
        `,
      });
      if (respuesta.personaFindNroDoc) {
        respuesta.personaFindNroDoc.id_tipo_documento = parseInt(
          respuesta.personaFindNroDoc.id_tipo_documento
        );
        this.persona = respuesta.personaFindNroDoc;
        if (respuesta.personaFindNroDoc.movilidades.length > 0 && respuesta.personaFindNroDoc.movilidades) {
          this.$message.error('El número de documento ya tiene un item asigando')
          this.repetido = true
        } else {
          this.repetido = false
        }
      }
    },
    async obtenerTipoExpedicion() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"CARNET DE IDENTIDAD"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.tipo_expedido = respuesta.params.rows;
    },
    async obtenerCargos() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            cargos{
              rows{
                id
                denominacion
              }
            }
          }
        `,
      });
      this.tipo_cargo = respuesta.cargos.rows;
    },
    async obtenerPuestos() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            puestos{
              rows{
                id
                denominacion
              }
            }
          }
        `,
      });
      this.tipo_puesto = respuesta.puestos.rows;
    },
    async obtenerUnidad() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            unidads(id_estado:17,id_entidad:35){
              rows{
                id
                nombre_unidad
              }
            }
          }
        `,
      });
      this.unidades = respuesta.unidads.rows;
    },
    async obtenerItemsDisponibles() {
      try {
        this.loading = true;
        let res = await this.$service.graphql({
          query: `
            query{
              vItemCargos(libre: 1){
                rows{
                   id_item
                  nro_item
                  nombre_unidad
                  cargo
                  id_cargo
                  sueldo
                  libre
                  id_unidad
                  padres_unidad
                }
              }
            }
          `,
        });
        this.itemsDisponibles = res.vItemCargos.rows;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    cargarDatos() {
      const elemento = this.itemsDisponibles.find(
        (item) => item.id_item === this.form.id_item
      );
      this.movilidad.id_unidad = elemento.id_unidad.toString();
      this.movilidad.id_cargo = elemento.id_cargo.toString();
    },
    async save() {
      if (this.persona.ap_paterno === "" && this.persona.ap_materno === "") {
        this.$message.error("Falta Apellido Paterno o Apellido Materno");
      } else {
        if (this.$refs.form.validate()) {
          this.loading = true;
          let user = this.$storage.get("user");
          if (this.persona.nro_complemento == null) {
            this.persona.nro_complemento = "";
          }
          if (this.persona.ap_casada == null) {
            this.persona.ap_casada = "";
          }

          this.movilidad.fecha = this.date;
          let respuesta;
          try {
            respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select persona.fn_alta_persona_movi(${this.persona.id_tipo_documento},'${this.persona.nro_doc}','${this.persona.nro_complemento}','${this.persona.expedido}','${this.persona.sexo}','${this.persona.ap_paterno.toUpperCase()}','${this.persona.ap_materno.toUpperCase()}','${this.persona.ap_casada.toUpperCase()}','${this.persona.nombres.toUpperCase()}',${user.id},'${this.movilidad.fecha}','${this.movilidad.nro_memorandum}',${parseInt(this.movilidad.id_unidad)},${parseInt(this.movilidad.id_puesto)},${parseInt(this.movilidad.id_cargo)},${this.form.nro_item})"){
                  respuesta
                }
              }
            `,
            });
            this.$message.success();
          } catch (error) {
            console.log(error);
          }
          this.loading = false;
          this.close();
        }
      }
    },
  },
};
</script>

<style>
.mayuscula input {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/CrearPersona.vue